import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import BookmakerCard from "@/components/BookmakerCard";

export default function BookmakerPage() {
  const [bookmakers, setBookmakers] = useState([]);
  useEffect(() => {
    api.get("/bookmakers").then((r) => setBookmakers(r.data)).catch(() => {});
  }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 sm:py-20">
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-500">
        Partner ufficiali
      </span>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">
        Scegli il <span className="text-yellow-400">bookmaker</span>
      </h1>
      <p className="mt-4 max-w-2xl text-zinc-400">
        Consulta le promozioni disponibili e registrati attraverso i link
        ufficiali Vinko.
      </p>

      <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {bookmakers.map((bm) => (
          <BookmakerCard key={bm.id} bm={bm} />
        ))}
      </div>
    </div>
  );
}
